import { Project } from '../../project/Project';
import { checkThat } from '../checkThat';

export const buildingCanBeRemoved = <P extends Project>(project: P): boolean =>
  project.buildings.length > 1;

export const checkThatCanRemoveABuilding = (project: Project) =>
  checkThat(buildingCanBeRemoved, 'You can’t remove the last building', project);
